// import Definition from './Definition';

export default {
  priority: 10,
  path: 'assignment',
  permissions: ['TimeAttendanceMenu/Settings/Assignment'],
  // component: Definition,
  component: load(() => import(/* webpackChunkName: "Shift-Definition" */ './Assignment')),
  name: app.translate('routes.home.Assignment'),
  icon: 'account-check',
  drawer: true,
};



